import type { FieldValues } from 'react-hook-form';

import React from 'react';
import { Span } from '../Element';
import { type SpinnerProps, Spinner } from '../Spinner';
import { useFormContext } from './FormContext';


interface StateIndicatorProps extends Omit<SpinnerProps, 'children'> {
	doingReCaptchaGet?: boolean;
	doingReCaptchaVerify?: boolean;
	doingSend?: boolean;
	textWhenReCaptchaGet?: string;
	textWhenReCaptchaVerify?: string;
	textWhenSending?: string;
	textWhenValidating?: string;
}


export const StateIndicator = <TSchema extends FieldValues>({
	doingReCaptchaGet,
	doingReCaptchaVerify,
	doingSend,
	size = 'large',
	textWhenReCaptchaGet,
	textWhenReCaptchaVerify,
	textWhenSending,
	textWhenValidating,
	variant,
}: StateIndicatorProps): React.JSX.Element | null => {
	const {
		formState: {
			isValidating: doingValidation,
		},
	} = useFormContext<TSchema>();

	function textFromState(): string | undefined {
		if (doingReCaptchaVerify) return textWhenReCaptchaVerify;
		if (doingReCaptchaGet) return textWhenReCaptchaGet;
		if (doingValidation) return textWhenValidating;
		if (doingSend) return textWhenSending;
		return ''; // Never displayed
	}

	const text = textFromState();
	if (!text) return null;

	return (
		<Spinner size={size} variant={variant}>
			<Span textSize='lg'>
				{text}
			</Span>
		</Spinner>
	);
};
